/* GTJ 2026-08-25 — quick-add + toast for product cards.
   Moved here out of snippets/product-card.liquid, where it was rendered inline
   once PER CARD: 6,171 bytes x 24 cards = ~145KB of byte-identical JavaScript on
   every collection page. The window.gtjQuickAddInit guard meant only the first
   copy ever executed; the other 23 were pure download weight.

   GTJ 2026-10-07 — tap speed (Shopify web_performance: mobile collection INP 684 ms).
   1. "Added!" + toast now show as soon as the add succeeds. The cart drawer refresh
      (Horizon cart:update -> ~2,800 DOM changes) is queued, coalesced across rapid
      adds, and run after the taps stop, so the next tap is never stuck behind it.
   2. On phone-width grids, off-screen product cards are skipped when the browser
      restyles the page (content-visibility).
   Before/after numbers: GreenTreeJewelry.com\Site-Speed\LEDGER.csv. */
(function() {
  if (window.gtjQuickAddInit) return;
  window.gtjQuickAddInit = true;

  // (2) Skip restyle/layout work for product cards that are off screen (phones only).
  try {
    var gtjPerfStyle = document.createElement('style');
    gtjPerfStyle.id = 'gtj-tap-speed';
    gtjPerfStyle.textContent = '@media screen and (max-width: 749px){.product-grid__item{content-visibility:auto;contain-intrinsic-size:auto 330px;}}';
    document.head.appendChild(gtjPerfStyle);
  } catch (eStyle) {}

  function gtjCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function(el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids.join(',');
  }

  function gtjToast(title) {
    var host = document.getElementById('gtj-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'gtj-toast-host';
      host.style.cssText = 'position:fixed;top:16px;right:16px;z-index:2147483000;display:flex;flex-direction:column;gap:10px;';
      document.body.appendChild(host);
    }
    var t = document.createElement('div');
    t.style.cssText = 'min-width:230px;max-width:320px;background:#2d5016;color:#ffffff;border-radius:8px;box-shadow:0 6px 24px rgba(0,0,0,0.18);padding:12px 14px;font-size:14px;line-height:1.35;transform:translateX(120%);opacity:0;transition:transform .28s ease,opacity .28s ease;';
    var head = document.createElement('div');
    head.style.cssText = 'display:flex;align-items:center;gap:8px;font-weight:600;';
    var chk = document.createElement('span');
    chk.textContent = '✓';
    chk.style.cssText = 'display:inline-flex;width:18px;height:18px;border-radius:50%;background:#ffffff;color:#2d5016;align-items:center;justify-content:center;font-size:12px;flex:0 0 auto;';
    var lbl = document.createElement('span');
    lbl.textContent = 'Added to cart';
    head.appendChild(chk); head.appendChild(lbl); t.appendChild(head);
    if (title) {
      var d = document.createElement('div');
      d.textContent = title;
      d.style.cssText = 'margin-top:4px;opacity:.92;';
      t.appendChild(d);
    }
    var a = document.createElement('a');
    a.href = '/cart';
    a.textContent = 'View cart';
    a.style.cssText = 'display:inline-block;margin-top:8px;color:#ffffff;text-decoration:underline;font-weight:600;';
    t.appendChild(a);
    host.appendChild(t);
    requestAnimationFrame(function() { t.style.transform = 'translateX(0)'; t.style.opacity = '1'; });
    setTimeout(function() {
      t.style.transform = 'translateX(120%)'; t.style.opacity = '0';
      setTimeout(function() { t.remove(); }, 300);
    }, 2000);
  }

  // (1) Cart refresh queue. Every successful add lands here; one cart:update goes out
  // after the taps stop (350 ms). If several adds were coalesced, or
  // responses came back out of order, the section HTML is left out so Horizon's
  // cart-items-component fetches a fresh copy itself.
  var gtjRefreshTimer = null;
  var gtjRefreshCount = 0;
  var gtjRefreshSections = null;
  var gtjRefreshFallbackCount = 1;

  function gtjQueueCartRefresh(sections, qty) {
    gtjRefreshCount += 1;
    gtjRefreshSections = sections || null;
    gtjRefreshFallbackCount = qty;
    clearTimeout(gtjRefreshTimer);
    gtjRefreshTimer = setTimeout(gtjFlushCartRefresh, 350);
  }

  function gtjFlushCartRefresh() {
    var coalesced = gtjRefreshCount;
    var sections = coalesced === 1 ? gtjRefreshSections : null;
    var fallbackCount = gtjRefreshFallbackCount;
    gtjRefreshCount = 0;
    gtjRefreshSections = null;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .catch(function() { return {}; })
      .then(function(cart) {
        // A newer add arrived while we were fetching: let its flush do the update.
        if (gtjRefreshCount > 0) return;
        var run = function() {
          // Fire Horizon's native cart:update so the cart icon count updates
          // and the cart drawer refreshes (same behavior as the product page).
          var data = {
            source: 'gtj-quick-add',
            itemCount: (typeof cart.item_count === 'number') ? cart.item_count : fallbackCount
          };
          if (sections) data.sections = sections;
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'gtj-quick-add', data: data }
          }));
        };
        setTimeout(run, 0);
      });
  }

  document.addEventListener('click', async function(e) {
    var target = e.target.closest('[data-gtj-action]');
    if (!target) return;
    var container = target.closest('[data-gtj-quick-add]');
    if (!container) return;
    e.preventDefault();
    e.stopPropagation();
    var qtyEl = container.querySelector('[data-gtj-qty]');
    var current = parseInt(qtyEl.textContent, 10) || 1;
    var action = target.getAttribute('data-gtj-action');
    if (action === 'inc') {
      qtyEl.textContent = Math.min(current + 1, 99);
    } else if (action === 'dec') {
      qtyEl.textContent = Math.max(current - 1, 1);
    } else if (action === 'add') {
      var btn = container.querySelector('[data-gtj-action="add"]');
      var variantId = container.getAttribute('data-variant-id');
      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) ? Theme.routes.cart_add_url : '/cart/add.js';
      // Fly-to-cart animation (same visual as the product page): product image flies to the cart icon.
      try {
        var cartIcon = document.querySelector('.header-actions__cart-icon');
        var flyImg = container.getAttribute('data-gtj-image');
        if (cartIcon && flyImg && customElements.get('fly-to-cart')) {
          var fly = document.createElement('fly-to-cart');
          fly.classList.add('fly-to-cart--quick');
          fly.style.width = '64px';
          fly.style.height = '64px';
          fly.style.backgroundSize = 'cover';
          fly.style.backgroundPosition = 'center';
          fly.style.borderRadius = '8px';
          fly.style.setProperty('--width', '64px');
          fly.style.setProperty('--height', '64px');
          fly.style.setProperty('background-image', 'url(' + flyImg + ')');
          fly.source = btn;
          fly.destination = cartIcon;
          document.body.appendChild(fly);
        }
      } catch (eFly) {}
      btn.setAttribute('data-state', 'loading');
      btn.textContent = 'Adding...';
      try {
        var addRes = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({
            id: variantId,
            quantity: current,
            sections: gtjCartSectionIds(),
            sections_url: window.location.pathname
          })
        });
        if (!addRes.ok) throw new Error('Add failed');
        var addData = await addRes.json();

        // Confirm to the buyer first...
        btn.setAttribute('data-state', 'added');
        btn.textContent = 'Added!';
        gtjToast(container.getAttribute('data-gtj-title'));

        // ...then refresh the cart icon + drawer off the tap path.
        gtjQueueCartRefresh(addData.sections, current);

        setTimeout(function() {
          btn.removeAttribute('data-state');
          btn.textContent = 'Add to cart';
        }, 1500);
      } catch (err) {
        btn.removeAttribute('data-state');
        btn.textContent = 'Try again';
        setTimeout(function() { btn.textContent = 'Add to cart'; }, 1500);
      }
    }
  });
  document.addEventListener('mousedown', function(e) {
    if (e.target.closest('[data-gtj-quick-add]')) {
      e.stopPropagation();
    }
  }, true);
})();